import { Quiz } from '@/models/Quiz';
import { QuizContent } from '@/models/QuizContent';
import { QuizData } from '@/models/QuizData';
import { QuizResult } from '@/models/QuizResult';
import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { QuizState, QuizTypes } from './types';

const INITIAL_STATE: QuizState = {
    data: {
        autoExecutable: {} as Quiz,
        quizData: {
            quiz: {} as Quiz,
            quizContent: {} as QuizContent,
            quizResults: [] as QuizResult[],
            quizQuestions: [],
        } as QuizData,
        quizzes: [] as QuizContent[],
    },
    loading: false,
    success: false,
    hasError: false,
    error: undefined,
};

const reducer: Reducer<QuizState> = (state: QuizState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case QuizTypes.CLEAR_QUIZ:
            return { ...INITIAL_STATE };
        case QuizTypes.GET_QUIZ_RESULT_LIST_REQUEST:
        case QuizTypes.GET_QUIZ_RESULT_REQUEST:
        case QuizTypes.GET_QUIZ_QUESTION_LIST_REQUEST:
        case QuizTypes.POST_QUIZ_RESULT_REQUEST:
        case QuizTypes.POST_QUIZ_REQUEST:
        case QuizTypes.POST_QUIZ_QUESTION_REQUEST:
            return { ...state, loading: true, hasError: false, success: false };
        case QuizTypes.GET_QUIZ_RESULT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: {
                    ...state.data,
                    quizData: {
                        ...state.data.quizData,
                        quizResults: action.payload,
                    },
                },
            };
        case QuizTypes.GET_QUIZ_QUESTION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: {
                    ...state.data,
                    quizData: {
                        ...state.data.quizData,
                        quizQuestions: action.payload,
                    },
                },
            };
        case QuizTypes.POST_QUIZ_SUCCESS:
            return {
                ...state,
                loading: false,
                hasError: false,
                success: true,
                data: { ...state.data, quizData: action.payload },
            };
        case QuizTypes.GET_QUIZ_RESULT_SUCCESS:
        case QuizTypes.POST_QUIZ_RESULT_SUCCESS:
            const quizResults = state.data.quizData.quizResults;
            quizResults.push(action.payload);
            return {
                ...state,
                loading: false,
                hasError: false,
                success: true,
                data: {
                    ...state.data,
                    quizData: {
                        ...state.data.quizData,
                        quizResults: quizResults,
                    },
                },
            };
        case QuizTypes.POST_QUIZ_QUESTION_SUCCESS:
            const { quizQuestions } = state.data.quizData;
            quizQuestions.push(action.payload);
            return {
                ...state,
                loading: false,
                hasError: false,
                success: true,
                data: {
                    ...state.data,
                    quizData: {
                        ...state.data.quizData,
                        quizQuestions,
                    },
                },
            };
        case QuizTypes.GET_QUIZ_RESULT_LIST_FAILURE:
        case QuizTypes.GET_QUIZ_RESULT_FAILURE:
        case QuizTypes.POST_QUIZ_RESULT_FAILURE:
        case QuizTypes.POST_QUIZ_QUESTION_FAILURE:
        case QuizTypes.POST_QUIZ_FAILURE:
            return { ...state, loading: false, hasError: true, error: action.payload, success: false };
        case QuizTypes.GET_AUTO_EXECUTABLE_QUIZ_SUCCESS:
            return { ...state, data: { ...state.data, autoExecutable: action.payload } };
        case QuizTypes.PUT_QUIZ_QUESTION_REORDER_REQUEST:
            return { ...state, loading: true };
        case QuizTypes.PUT_QUIZ_QUESTION_REORDER_SUCCESS:
            return { ...state, loading: false };
        case QuizTypes.PUT_QUIZ_QUESTION_REORDER_FAILURE:
            return { ...state, hasError: true };
        default:
            return state;
    }
};

export default reducer;
